// ProfileService.js
import axiosInstance from '../../api/auth/axiosInstance';
import Swal from 'sweetalert2';

export const ProfileService = {
  getPatientUserByPatientUserId: async (patientUserId) => {
    try {
      const response = await axiosInstance.get(`/patient-user/patient-user-id/${patientUserId}`, {
        headers: { authType: "PostLogin" }
      });
      return response;
    } catch (error) {
      console.error("Error fetching patient user details:", error);
      Swal.fire({
        title: 'Failed!',
        text: `Error fetching patient user details: ${(error.response?.data?.statusDescription || error.message)}`,
        icon: 'error',
        confirmButtonColor: '#566fe2',
        customClass: {
          title: 'swal-title-small',
          popup: 'swal-popup-small',
          confirmButton: 'swal-button-small'
        }
      });
      throw error;
    }
  },
  upsertPatientUserDetails: async (patientUserId, payLoad) => {
    try {
      const response = await axiosInstance.put(`/patient-user/upsert/${patientUserId}`, payLoad, {
        headers: { authType: "PostLogin" }
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Changes done: " + response.data.data,
      });
      return response.data;
    } catch (error) {
      console.error("Error upserting details:", error);
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Error changing details: " + (error.response?.data?.statusDescription || error.message),
      });
      throw error;
    }
  },
  sendOtp: async (patientUserId) => {
    try {
      const response = await axiosInstance.post(`/patient-user/send-otp/${patientUserId}`, {}, {
        headers: { authType: "PostLogin" }
      });
      return response.data;
    } catch (error) {
      console.error("Error sending OTP:", error);
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Error sending OTP: " + (error.response?.data?.statusDescription || error.message),
      });
      throw error;
    }
  },
  changePassword: async (patientUserId, payLoad) => {
    try {
      const response = await axiosInstance.put(`/patient-user/change-password/${patientUserId}`, payLoad, {
        headers: { authType: "PostLogin" }
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Password changed: " + response.data.data,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Error changing password: " + (error.response?.data?.statusDescription || error.message),
      });
      throw error;
    }
  },
};

export default ProfileService;